import { Link as LinkMagik, Pagination, createTable } from "@inmagik/magik-ui"
import { Esemplare, FiltersBase } from "../../types"
import { useMemo } from "react"
import { PAGE_SIZE } from "../../constants"
import { Link } from "react-router-dom"

const Table = createTable<Esemplare>()

export function TableEsemplari({
  esemplari,
  setFilters,
  filters,
  count,
  fullCount,
  showEdizione = true,
  actionLink,
}: {
  esemplari: Esemplare[]
  setFilters: (nextFilters: Partial<FiltersBase>) => void
  filters: FiltersBase
  count: number
  fullCount: number
  showEdizione?: boolean
  actionLink?: (v?: Esemplare) => void
}) {
  const numPages = useMemo(() => {
    if (!esemplari) {
      return 1
    }
    return Math.ceil(count / PAGE_SIZE)
  }, [esemplari, count])

  return (
    <Table
      data={esemplari}
      className="w-100 overflow-scroll flex-1"
      orderBy={filters.ordering.replace("-", "")}
      orderDirection={filters.ordering.startsWith("-") ? "desc" : "asc"}
      onOrderChange={(field, direction) => {
        if (field) {
          if (direction === "desc") {
            setFilters({ ...filters, ordering: `-${field}` })
          } else {
            setFilters({ ...filters, ordering: field })
          }
        } else {
          setFilters({ ...filters, ordering: "" })
        }
      }}
    >
      <Table.HeaderConfig sticky />

      <Table.BodyConfig />
      <Table.Column
        title="Codice"
        name="codice"
        sortable
        stickyLeft
        width="minmax(max-content, 1fr)"
        render={(esemplare) => (
          actionLink ? (
            <LinkMagik className="text-dark" onClick={() => actionLink(esemplare)} style={{ cursor: "pointer" }}>
              {esemplare.codice}
            </LinkMagik>
          ) : (
            <Link to={`/edizioni/esemplari/${esemplare.id}/`}>
              <LinkMagik className="text-dark">{esemplare.codice}</LinkMagik>
            </Link>
          )
        )}
      />
      {showEdizione && (
        <Table.Column
          title="Edizione"
          name="titolo_completo_edizione"
          sortable
          width="minmax(max-content, 1fr)"
          render={(esemplare) => <div>{esemplare.edizione_data.opera_data.titolo} - {esemplare.titolo_completo_edizione}</div>}
        />
      )}
      <Table.Column
        title="Biblioteca"
        name="biblioteca__nome"
        sortable
        width="minmax(max-content, 1fr)"
        render={(esemplare) => esemplare.biblioteca_data?.nome}
      />
      <Table.Column
        title="Città"
        name="biblioteca__citta"
        sortable
        width="minmax(max-content, 1fr)"
        render={(esemplare) => esemplare.biblioteca_data?.citta}
      />
      <Table.Column
        title="Digitalizzato"
        name="digitalizzato"
        sortable
        width="minmax(max-content, 1fr)"
        render={(esemplare) => (esemplare.digitalizzato ? "Sì" : "No")}
      />
      <Table.Column
        title="Consultato"
        name="consultato"
        sortable
        width="minmax(max-content, 1fr)"
        render={(esemplare) => (esemplare.consultato ? "Sì" : "No")}
      />
      <Table.Column
        title="Ordine"
        name="ordine"
        sortable
        width="minmax(max-content, 1fr)"
        render={(esemplare) => esemplare.ordine}
      />
      <Table.Footer.Left>
        Stai visualizzando {count} di {fullCount} esemplari
      </Table.Footer.Left>
      <Table.Footer.Center>
        <Pagination page={filters.page} numPages={numPages} onPageChange={(page) => setFilters({ ...filters, page })} />
      </Table.Footer.Center>
    </Table>
  )
}
